
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discuss/[slugId]",
      function () {
        return require("private-next-pages/discuss/[slugId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discuss/[slugId]"])
      });
    }
  